import {
  AbsoluteCenter,
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Portal,
} from "@chakra-ui/react";
import loglevel from "loglevel";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { InfoCircleIcon } from "shared/icons/InfoCircleIcon";
import { useInterval } from "usehooks-ts";
import { useRegisterSW } from "virtual:pwa-register/react";

const UPDATE_INTERVAL_MS = 1000 * 60 * 5; // 5 minutes

const log = loglevel.getLogger("AppUpdatePrompt");

export const AppUpdatePrompt: React.FC = () => {
  const { t } = useTranslation(["common"]);

  const [swReg, setSwReg] = useState<ServiceWorkerRegistration | undefined>();

  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    immediate: true,
    onRegisteredSW(swUrl, reg) {
      log.debug("SW registered", swUrl, reg);
      setSwReg(reg);
    },
    onRegisterError(error) {
      log.error("SW registration error", error);
    },
    onNeedRefresh: () => {
      log.debug("SW update available");
      setNeedRefresh(true);
    },
  });

  useInterval(
    () => {
      log.debug("Checking for SW update");
      void swReg?.update();
    },
    swReg && !needRefresh ? UPDATE_INTERVAL_MS : null,
  );

  return needRefresh ? (
    <Portal>
      <AbsoluteCenter axis="horizontal">
        <Alert
          data-ls-enabled={true}
          data-public={true}
          mt="7px"
          onClick={() => {
            void updateServiceWorker(true);
          }}
        >
          <AlertIcon>
            <InfoCircleIcon />
          </AlertIcon>
          <AlertTitle flexGrow="0">{t("common:appUpdate.title")}</AlertTitle>
          <AlertDescription>
            {t("common:appUpdate.description")}
          </AlertDescription>
        </Alert>
      </AbsoluteCenter>
    </Portal>
  ) : null;
};
